export default {
  APPID: 'd6516c64-627d-44b5-8563-b025bcb3b2a1',
};
